import { action, configure, makeObservable, observable } from 'mobx';

export interface EnvironmentVariables {
  production?: boolean,
  jwt?: string,
  gtmTrackingId?: string,
  whitelabelHost?: string,
  restApiBaseURL?: string,
  isInternalChatString?: string,
  isInternalAppString?: string,
  productName?: string,
  contentfulParams?: {
    space: string,
    accessToken: string,
    previewToken: string,
    environment?: string,
  },
  features?: {
    // loanChatMeet used to live here, hard-coded true in every build. It is served by
    // GET /api/v1/vendor/call/capabilities now — see MeetCapabilitiesStore.
    privateChat?: boolean
  },
  mapBoxToken?: string
}

export class EnvironmentStore {
  environmentVariables: EnvironmentVariables;

  constructor(environmentVariables: EnvironmentVariables) {
    this.environmentVariables = environmentVariables;
    makeObservable(this, {
      environmentVariables: observable
    });
  }

}

configure({
  enforceActions: 'never',
});
